import { InboxOutlined } from '@ant-design/icons';
import { Input, Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload';
import TableActionHeader from 'components/Global/TableActionHeader';
import { useState } from 'react';
import toast from 'react-hot-toast';
import styles from './index.module.scss';

const isCsvFile = (file: UploadFile) =>
	file.name?.toLowerCase().endsWith('.csv') ?? false;

const ImportDataBody = () => {
	const [tag, setTag] = useState('');
	const [fileList, setFileList] = useState<UploadFile[]>([]);

	const handleBeforeUpload = (file: UploadFile) => {
		if (!isCsvFile(file)) {
			toast.error('Only .csv files are supported');
			return Upload.LIST_IGNORE;
		}
		return false;
	};

	const handleChange = ({
		fileList: newFileList,
	}: {
		fileList: UploadFile[];
	}) => {
		setFileList(newFileList.filter(isCsvFile));
	};

	return (
		<>
			<TableActionHeader title="Import Data" />
			<div className={styles['import-data']}>
				<div className={styles['import-data__field']}>
					<label className={styles['import-data__label']} htmlFor="import-tag">
						Tag
					</label>
					<Input
						id="import-tag"
						placeholder="Enter tag"
						value={tag}
						onChange={(e) => setTag(e.target.value)}
						maxLength={255}
					/>
				</div>

				<div className={styles['import-data__uploader']}>
					<label className={styles['import-data__label']}>CSV file</label>
					<Upload.Dragger
						accept=".csv"
						maxCount={1}
						fileList={fileList}
						beforeUpload={handleBeforeUpload}
						onChange={handleChange}
						onRemove={() => {
							setFileList([]);
							return true;
						}}
					>
						<p className="ant-upload-drag-icon">
							<InboxOutlined />
						</p>
						<p className="ant-upload-text">
							Click or drag a CSV file to this area
						</p>
					</Upload.Dragger>
					<p className={styles['import-data__hint']}>
						Only .csv files are supported
					</p>
				</div>
			</div>
		</>
	);
};

export default ImportDataBody;
